"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const handleError_1 = require("../Environment/handleError");
const Environment_1 = require("../Environment");
const env = process.env.NODE_ENV === 'production' ? '' : 'staging.';
const uri = `https://api.${env}rover.io/v1/experience-list-items/?filter[collectionType]=published&page[size]=150`;
exports.fetchExperiences = () => (dispatch) => {
    dispatch({ type: 'FETCH_EXPERIENCES_REQUEST' });
    const headers = Environment_1.generateHeaders();
    const options = {
        method: 'GET',
        headers,
    };
    return fetch(uri, options)
        .then((res) => {
        if (!res.ok) {
            throw [{ message: res.status }];
        }
        return res;
    })
        .then((res) => res.json())
        .then(({ data }) => {
        const experiences = data.map((experience) => ({
            id: experience.id,
            name: experience.attributes.name,
            simulatorURL: experience.attributes['simulator-url'],
            homeScreenId: experience.attributes['home-screen-id'],
            screens: experience.attributes.screens,
        }));
        return dispatch({
            type: 'FETCH_EXPERIENCES_SUCCESS',
            experiences,
        });
    })
        .catch((errors) => handleError_1.default('FETCH_EXPERIENCES_ERROR', dispatch, errors[0].message.toString()));
};
